import { Component, Input, OnInit } from '@angular/core';
import { FieldArrayType } from '@ngx-formly/core';
import { COMMON_STANDALONE_IMPORTS } from 'src/app/components/common-standalone-imports';

@Component({
  imports: [COMMON_STANDALONE_IMPORTS],
  selector: 'repeat',
  templateUrl: './repeat.component.html',
  styles: ``,
})
export class RepeatComponent extends FieldArrayType implements OnInit {
  collapsed = true;
  ngOnInit(): void {}

  add() {
    if(this.field.props.disabled) {
      return;
    }
    if(this.field.props.initialModel){
      console.log('this.field.props.initialModel:', this.field.props.initialModel)
      super.add(this.model?.length || 1, this.field.props.initialModel);
    } else {
      super.add()
    }
    this.collapsed = false;
  }

  toggleCollapsed() {
    this.collapsed = !this.collapsed;
  }

  remove(i) {
    if(this.field.props.disabled) {
      return;
    }
    super.remove(i)
  }
  
}
